import { boxConsumableValidate } from '../../application/dtos/box_consumable_validate'

export class boxConsumableEntity {
    constructor({stockMin, stock, stockDamaged, stockStolen, warehouseId, consumable}){
        this.stockMin = stockMin;
        this.stock = stock;
        this.stockDamaged = stockDamaged;
        this.stockStolen = stockStolen;
        this.warehouseId = warehouseId;
        this.consumable = consumable;
    }

    isValid() {
        return boxConsumableValidate(this);
    }
}